<template>
  <nav>
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ disabled: paging.pageNum === 1 }" role="button">
        <a class="page-link" id="back" @click="previousPage">Nazaj</a>
      </li>
      <li class="page-item" :class="{ disabled: paging.pageNum === paging.pages || paging.pages <= 1 }" role="button">
        <a class="page-link" id="forward" @click="nextPage">Naprej</a>
      </li>
    </ul>
  </nav>
  <div class="row">
    <div class="col">
      <p class="justify-content-center">
        Stran {{ paging.pageNum }} od {{ paging.pages }}. <span v-show="isAdmin">Skupaj: {{ paging.numberOfRecords }}</span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  isAdmin,
  showMessageToWorker,
} from "../composition-api/useAuth"

defineOptions({ name: "Paging" })

const props = defineProps({
    paging: Object,
  })

const emit = defineEmits(["change"])

const previousPage = () => {
  if (props.paging.pageNum === 1) return
  emit("change", props.paging.pageNum - 1)
}

const nextPage = () => {
  if (props.paging.pageNum >= props.paging.pages) return
  emit("change", props.paging.pageNum + 1)
}
</script>
